import { render } from "./FaceBox.vue?vue&type=template&id=7c3a8c4c&scoped=true&ts=true"
import script from "./FaceBox.vue?vue&type=script&lang=ts"
export * from "./FaceBox.vue?vue&type=script&lang=ts"

import "./FaceBox.vue?vue&type=style&index=0&id=7c3a8c4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3a8c4c"]])

export default __exports__